import { render, staticRenderFns } from "./jiazhi.vue?vue&type=template&id=3e134dfa&scoped=true&"
import script from "./jiazhi.vue?vue&type=script&lang=js&"
export * from "./jiazhi.vue?vue&type=script&lang=js&"
import style0 from "./jiazhi.vue?vue&type=style&index=0&id=3e134dfa&lang=scss&scoped=true&"
import style1 from "./jiazhi.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e134dfa",
  null
  
)

export default component.exports